function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    /* prettier-ignore */\n    ", " \n    margin-right: ", "px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import Spacing, { BASE_SPACING, BASE_STYLES } from './constants';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withDynamicTag } from '@doordash/utilities';
var Inline = withDynamicTag(styled.div(_templateObject(), BASE_STYLES, function (props) {
  return props.size;
}));
Inline.Sizes = Spacing;
Inline.propTypes = {
  size: PropTypes.oneOf(Object.values(Inline.Sizes))
};
Inline.defaultProps = {
  size: BASE_SPACING
};
export default Inline;